import React from 'react';
import RelacionesTaraFardos from '../../components/relacion/ListarTaraFardos';

const ListarTaraFardos: React.FC = () => {
  return (
    <div style={{ padding: '20px', textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>

      <RelacionesTaraFardos />


    </div>

  );
};

export default ListarTaraFardos;